import type { ListConfig } from "src/system/module.types.ts";
import type { ClientConfig } from "src/client-config/getClientConfig.ts";

type ReturnType = {
  config: ListConfig<any> | { (client: ClientConfig): ListConfig<any> };
};

export const fetchResourceListConfig = async ({
  resource,
  clientConfig,
}: {
  resource: string;
  clientConfig: ClientConfig;
}): Promise<ListConfig<any>> => {
  const lists = import.meta.glob("../admin/lists/**/list.tsx");

  const importPath = `../admin/lists/${resource}/list.tsx`;

  if (Object.keys(lists).includes(importPath)) {
    const listConfig = ((await lists[importPath]()) as ReturnType).config;
    return typeof listConfig === "function"
      ? listConfig(clientConfig)
      : listConfig;
  }

  throw new Error(
    `fetchResourceListConfig is not implemented for [${resource}] resource`,
  );
};
